import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ReactElement } from "react";

export const AplicativosCard = ({
  icon,
  titleCard,
  textCard,
  customIcon,
}: {
  icon?: IconProp;
  titleCard: string;
  textCard: string;
  customIcon?: ReactElement;
}) => {
  return (
    <div className="aplicativos-page__card">
      <div className="card-header border-0 bg-white">
        {icon ? (
          <span className="text-blue pt-3">
            <FontAwesomeIcon icon={icon} size="5x" />
          </span>
        ) : null}
        {customIcon ? customIcon : null}
      </div>
      <div className="card-body">
        <h4 className="font-weight-bold text-blue py-4">{titleCard}</h4>
        <p>{textCard}</p>
      </div>
    </div>
  );
};
